(function(){
  function court(){
    var b = document.getElementById('shopify-pc__banner');
    if (!b || b.dataset.ls) return !!b;
    b.dataset.ls = '1';
    var t = document.getElementById('shopify-pc__banner__body-title');
    if (t) t.textContent = 'Cookies';
    var p = b.querySelector('.shopify-pc__banner__body p');
    var a = document.getElementById('shopify-pc__banner__body-policy-link');
    if (p) { p.textContent = 'Mesure d\u2019audience et publicité, seulement avec votre accord. '; if (a) { a.textContent = 'En savoir plus'; p.appendChild(a); } }
    var g = b.querySelector('#shopify-pc__banner__btn-manage-prefs span');
    if (g) g.textContent = 'Personnaliser';
    return true;
  }
  if (!court()) new MutationObserver(function(m, o){ if (court()) o.disconnect(); })
    .observe(document.documentElement, {childList: true, subtree: true});
})();
